module.exports = __webpack_public_path__ + "media/images/items/thumbnail-7-41e057d723728e077045bd104b81e7c8.jpg";